export const TRANSLATION_SCOPE = 'licenseManagerModule';
export const TRANSLATION_GRID_SCOPE = [TRANSLATION_SCOPE, 'grid'];
export const TRANSLATION_HISTORY_SCOPE = [TRANSLATION_SCOPE, 'crud'];
export const TRANSLATION_DEFAULT_SCOPE = [TRANSLATION_SCOPE, 'default'];
